import React, { useState, useRef, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import { useAnalytics } from '../../hooks/useAnalytics';
import './NavDropdown.css';

const NavDropdown = ({ label, items, icon }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const analytics = useAnalytics();
  const t = useTranslation();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  // Close dropdown when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const handleItemClick = (item) => {
    if (item.analytics) {
      analytics.trackCTAClick(item.analytics);
    }
    history.push(item.path);
    setIsOpen(false);
  };

  // Check if any item in the dropdown is active
  const isActive = items.some(item => {
    if (item.path === '/') {
      return location.pathname === '/' || location.pathname === '/personal-credit';
    }
    return location.pathname === item.path;
  });

  return (
    <div className="nav-dropdown" ref={dropdownRef}>
      <button
        className={`nav-dropdown-trigger ${isActive ? 'active' : ''} ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        {icon && <span className="nav-dropdown-icon">{icon}</span>}
        <span className="nav-dropdown-label">{label}</span>
        <span className="nav-dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className="nav-dropdown-menu">
          {items.map((item) => {
            const itemIsActive = item.path === '/' 
              ? (location.pathname === '/' || location.pathname === '/personal-credit')
              : location.pathname === item.path;
            
            return (
              <button
                key={item.path}
                className={`nav-dropdown-item ${itemIsActive ? 'active' : ''}`}
                onClick={() => handleItemClick(item)}
              >
                {item.icon && <span className="nav-dropdown-item-icon">{item.icon}</span>}
                <span>{item.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default NavDropdown;

